import type { OrgAccommodationRequest } from '~/gql/accommodations/accommodations'
import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'
import { Button } from '~/components/ui/button'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '~/components/ui/table'
import { ACCOMMODATION_STATUS_KEYS, ACCOMMODATION_STATUS_VARIANTS } from '~/helpers/accommodations/accommodation-labels'

type IProps = {
  requests: readonly OrgAccommodationRequest[]
  formatDate: (value: unknown) => string
  onOpen: (request: OrgAccommodationRequest) => void
}

/** Une ligne par demande (#327) : qui, quoi, depuis quand, et si c'est traité. */
function AccommodationsTable({ requests, formatDate, onOpen }: IProps) {
  const { t } = useTranslation()

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t('accommodations.column.learner')}</TableHead>
          <TableHead className="min-w-64">{t('accommodations.column.needs')}</TableHead>
          <TableHead>{t('accommodations.column.updatedAt')}</TableHead>
          <TableHead>{t('accommodations.column.status')}</TableHead>
          <TableHead><span className="sr-only">{t('accommodations.column.actions')}</span></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {requests.map(r => (
          <TableRow key={r.id}>
            <TableCell>
              <div className="flex flex-col">
                <span className="font-medium">{r.learnerName}</span>
                {r.learnerEmail && <span className="text-xs text-muted-foreground">{r.learnerEmail}</span>}
              </div>
            </TableCell>
            <TableCell className="min-w-64 whitespace-normal"><span className="line-clamp-2">{r.needs}</span></TableCell>
            <TableCell className="whitespace-nowrap">{formatDate(r.updatedAt)}</TableCell>
            <TableCell><Badge variant={ACCOMMODATION_STATUS_VARIANTS[r.status]}>{t(ACCOMMODATION_STATUS_KEYS[r.status])}</Badge></TableCell>
            <TableCell className="text-right">
              <Button variant="outline" size="sm" onClick={() => onOpen(r)} aria-label={t('common.actionFor', { action: t('accommodations.open'), name: r.learnerName })}>
                {t('accommodations.open')}
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default AccommodationsTable
